export default __webpack_public_path__ + "2f92ff7551e2447e649d14197671ce1b.jpg";